import { NextApiRequest, NextApiResponse } from "next";
import { Logger } from "#/lib/logging";
import { z } from "zod";
import { getProduct, ProductSchema } from "#/lib/stripe/get-product";


export const GetProductsResponseSchema = z.object({
  products: z.array(ProductSchema)
});
export type GetProductsResponse = z.infer<typeof GetProductsResponseSchema>;

const handler = async (
  req: NextApiRequest, res: NextApiResponse
) => {
  if (req.method !== "GET") {
    return res.status(405).json({ error: "Method not allowed" });
  }
  try {
    const products = await Promise.all([
      getProduct({ productId: process.env.NEXT_PUBLIC_STRIPE_PRO_ID }),
      getProduct({ productId: process.env.NEXT_PUBLIC_STRIPE_ENTERPRISE_ID })
    ]);
    res.status(200).json({ products });
  } catch (error) {
    Logger.error({
      message: "Error fetching Stripe products",
      error
    });
    res.status(500).json({ error: `Failed to fetch Stripe products\n${(error as any)?.message}` });
  }
};
export default handler;
// export default userRequestContextWrapper(withRateLimitWrapper(handler));
